import {Component, Input, output} from '@angular/core';

export const DEFAULT_UNAVAILABLE_TEXT = 'Data unavailable';

/**
 * The "Available Float" summary card on the Float Monitoring page. Strictly presentational — the parent owns the
 * balance fetch and currency formatting, and opens the top-up instructions when the card emits {@code topUp}.
 *
 * Only the current balance is wired today. The minimum-threshold gauge and the since-yesterday delta shown in the
 * design render the "data unavailable" placeholder until their backing endpoints exist.
 */
@Component({
    selector: 'app-available-float-card',
    templateUrl: './available-float-card.component.html',
    styleUrls: ['./available-float-card.component.scss'],
    standalone: false
})
export class AvailableFloatCardComponent
{
    @Input() balance: string | null = null;
    @Input() unavailable = false;
    @Input() unavailableText = DEFAULT_UNAVAILABLE_TEXT;
    readonly topUp = output<void>();
}
